import { render, staticRenderFns } from "./GovernmentStatus.vue?vue&type=template&id=224da1ce&"
import script from "./GovernmentStatus.vue?vue&type=script&lang=js&"
export * from "./GovernmentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports